// src/features/landing/presentation/components/RbBridgeAboutSection.jsx
// 회사소개(/about) — 사업 영역 확장으로서의 RB Bridge(M&A 사업부) 소개. 상세는 /rb-bridge.
import React from "react";
import { Link } from "react-router-dom";

const FACTS = [
    { label: "대상", value: "3억~20억 원 규모\n소형 보험 지사" },
    { label: "방식", value: "익명 등록 · 인수자 인증\nNDA 후 단계적 공개" },
    { label: "클로징", value: "프라이빗 미팅룸에서\n대면 협상·계약" },
];

export function RbBridgeAboutSection() {
    return (
        <section className="rba-section">
            <div className="rba-container">
                <p className="rba-kicker">M&amp;A 사업부 · RB Bridge</p>
                <h2 className="rba-title">
                    사람을 잇는 중개에서,
                    <br />
                    <span className="rba-accent">조직을 잇는 중개</span>로.
                </h2>
                <p className="rba-body">
                    15년 넘게 보험 인재를 연결하며 쌓은 노하우와 검증 시스템을 바탕으로, 라이징브로커즈는 이제 보험 지사 양수도까지 중개합니다.
                    대형 M&amp;A 시장과 개인 채용 시장 사이에서 다뤄지지 않던 소형 지사 거래를, 비공개 절차로 계약까지 맡습니다.
                </p>

                <div className="rba-connection" aria-label="양도 지사와 인수자를 RB Bridge가 연결">
                    <span className="rba-end">양도 지사</span>
                    <span className="rba-line" aria-hidden="true" />
                    <span className="rba-brand">[ RB Bridge ]</span>
                    <span className="rba-line" aria-hidden="true" />
                    <span className="rba-end">인수자 · 법인 GA</span>
                </div>

                <dl className="rba-facts">
                    {FACTS.map((f) => (
                        <div key={f.label} className="rba-fact">
                            <dt>{f.label}</dt>
                            <dd>
                                {f.value.split("\n").map((line, i) => (
                                    <React.Fragment key={i}>
                                        {i > 0 && <>{" "}<br /></>}
                                        {line}
                                    </React.Fragment>
                                ))}
                            </dd>
                        </div>
                    ))}
                </dl>

                <Link to="/rb-bridge" className="rba-button">RB 브릿지 알아보기</Link>
            </div>

            <style jsx>{`
                .rba-section {
                    background: #f7f4f1;
                    padding: 120px 20px;
                    word-break: keep-all;
                }
                .rba-container {
                    max-width: 1000px;
                    margin: 0 auto;
                    text-align: center;
                }
                .rba-kicker {
                    margin: 0 0 16px;
                    font-size: 13px;
                    font-weight: 700;
                    letter-spacing: 0.08em;
                    color: #c2926b;
                }
                .rba-title {
                    margin: 0;
                    font-size: 2.5rem;
                    line-height: 1.35;
                    font-weight: 800;
                    color: #1c1814;
                }
                .rba-accent {
                    color: #f16102;
                }
                .rba-body {
                    max-width: 720px;
                    margin: 28px auto 0;
                    font-size: 1.05rem;
                    line-height: 1.85;
                    color: #555;
                }
                .rba-connection {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 20px;
                    margin: 64px 0 56px;
                    font-size: 1.5rem;
                    font-weight: 700;
                }
                .rba-end {
                    color: #2c3e50;
                    white-space: nowrap;
                }
                .rba-line {
                    width: 96px;
                    height: 1px;
                    background: #c9b8a8;
                    flex-shrink: 1;
                }
                .rba-brand {
                    color: #f16102;
                    font-weight: 800;
                    font-size: 1.7rem;
                    white-space: nowrap;
                }
                .rba-facts {
                    display: grid;
                    grid-template-columns: repeat(3, minmax(0, 1fr));
                    margin: 0 0 48px;
                    border-top: 1px solid #e5ddd7;
                    border-bottom: 1px solid #e5ddd7;
                }
                .rba-fact {
                    padding: 28px 20px;
                }
                .rba-fact + .rba-fact {
                    border-left: 1px solid #e5ddd7;
                }
                .rba-fact dt {
                    margin-bottom: 10px;
                    font-size: 13px;
                    font-weight: 700;
                    color: #c2926b;
                }
                .rba-fact dd {
                    margin: 0;
                    font-size: 1.05rem;
                    line-height: 1.6;
                    font-weight: 700;
                    color: #1c1814;
                }
                .rba-button {
                    display: inline-flex;
                    align-items: center;
                    padding: 14px 32px;
                    border-radius: 999px;
                    background: #c2926b;
                    color: #fff;
                    font-size: 15px;
                    font-weight: 700;
                    text-decoration: none;
                    transition: background 0.2s ease;
                }
                .rba-button:hover {
                    background: #a97a55;
                }

                @media (max-width: 768px) {
                    .rba-section {
                        padding: 72px 20px;
                    }
                    .rba-title {
                        font-size: 1.7rem;
                    }
                    .rba-body {
                        font-size: 0.95rem;
                    }
                    .rba-connection {
                        flex-direction: column;
                        gap: 10px;
                        margin: 40px 0;
                        font-size: 1.05rem;
                    }
                    .rba-line {
                        width: 1px;
                        height: 20px;
                    }
                    .rba-brand {
                        font-size: 1.25rem;
                    }
                    .rba-facts {
                        grid-template-columns: minmax(0, 1fr);
                    }
                    .rba-fact {
                        padding: 20px 8px;
                    }
                    .rba-fact + .rba-fact {
                        border-left: 0;
                        border-top: 1px solid #e5ddd7;
                    }
                }
            `}</style>
        </section>
    );
}
